import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "css/brm-react-tabs.css";
import VulnerabilityTable from "brm/tables/details/VulnerabilityTable";
import AttackerTable from "brm/tables/details/AttackerTable";
import PropTypes from "prop-types";
import { DetailTableType } from "features/brm";

export const AllocatedControlTab = ({ selectedElement }) => {
  const elementNameInUrl = DetailTableType.ALLOCATED_CONTROLS.key;

  return (
    <Tabs>
      <TabList>
        <Tab>Vulnerability Conditions</Tab>
        <Tab>Attackers</Tab>
      </TabList>

      <TabPanel>
        <VulnerabilityTable elementNameInUrl={elementNameInUrl} selectedElement={selectedElement} />
      </TabPanel>
      <TabPanel>
        <AttackerTable elementNameInUrl={elementNameInUrl} selectedElement={selectedElement} />
      </TabPanel>
    </Tabs>
  );
};

AllocatedControlTab.propTypes = {
  selectedElement: PropTypes.object.isRequired,
};
